import React from "react";
import round from "lodash/round";
import convert from "convert-units";
import moment from "moment";
import { mapParameter } from "../../../../parts/other-exercise/CustomParametersSets";
import getStatus from "../../../../utils/status-exercises";
import convertToRiR from "../../../../utils/converters/convert-intensity";
import { repsValue } from "../../../../utils/reps-range";
import SvgIcon from "../../../../parts/SvgIcon";
import { getLoadDrop } from "../../../../utils/load-drop";

const {
  PARAMETER_OPTIONS: { FREEFORM, LOAD, RPE, RPEAMRAP, REPS },
} = require("../../../../constants");

const WeekParametersComponent = ({
  exercise,
  set,
  isAmrap,
  hasLoad,
  load,
  isAssistant,
  currentZone,
  withWeight,
  units,
  intensityMeasure,
  isRiR,
}) => {
  const status =
    moment(moment().subtract(1, "days").utc()).isAfter(
      moment(exercise.date).endOf("day").utc()
    ) || set.statusArray
      ? getStatus(set)
      : null;

  const StatusIcon =
    status === "Missed" ? (
      <SvgIcon src="/img/new-icons/info-circle.svg" noFilterOnLight={true} />
    ) : status === null ? null : (
      <SvgIcon src="/img/new-icons/tick-square.svg" noFilterOnLight={true} />
    );
  return (
    <div className="week-parameters">
      {!exercise.parameters ? (
        <>
          <span>{set.sets}</span>
          <span>{isAmrap ? "∞" : repsValue(set.reps, set.repsLower)}</span>
          <span>{isAmrap ? "" : convertToRiR(set.rpe, !isRiR)}</span>
          <span>
            {set.loadDrop
              ? getLoadDrop(set.loadDrop)
              : (hasLoad && load) ||
                (set.rpe
                  ? `${convertToRiR(set.rpe, !isRiR)} ${intensityMeasure}`
                  : "")}
          </span>
          {!isAssistant && (
            <span>
              {hasLoad && (
                <span className={`zone-dot zone-intensity ${currentZone}`}>
                  {set.load && set.percentRepMax
                    ? `${round(set.percentRepMax, 1)}%`
                    : ""}
                </span>
              )}
            </span>
          )}
        </>
      ) : (
        exercise.parameters.map((parameter, i) => (
          <span
            className={`${parameter === FREEFORM ? "!text-left" : ""} `}
            key={`${parameter}_index${i}`}
          >
            {parameter === LOAD
              ? set.loadDrop
                ? getLoadDrop(set.loadDrop)
                : set[mapParameter(parameter)]
                ? withWeight(
                    units === "metric"
                      ? set[mapParameter(parameter)]
                      : convert(set[mapParameter(parameter)])
                          .from("kg")
                          .to("lb")
                  )
                : null
              : [RPE, RPEAMRAP].includes(parameter)
              ? convertToRiR(set[mapParameter(parameter)], !isRiR)
              : parameter === REPS
              ? repsValue(set.reps, set.repsLower)
              : set[mapParameter(parameter)] || <span>&nbsp;</span>}
          </span>
        ))
      )}
      <span>{StatusIcon}</span>
    </div>
  );
};

export default WeekParametersComponent;
